import { onMounted } from "vue";
import { baseUrl, appId } from "@/utils";
const __default__ = {
  name: "HomeView"
};
export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props) {
    onMounted(() => {
      getWechatCode();
    });
    const getWechatCode = () => {
      let local = baseUrl + "/#/worker";

      // 不存在则打开地址进行授权
      window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appId + "&redirect_uri=" + encodeURIComponent(local) + "&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect";
    };
    return (_ctx, _cache) => {
      return null;
    };
  }
});